import styled from "styled-components"
import colors from "~constants/colors"

export const WizardContainer = styled.div`
  display: flex;
  flex-direction: column;

  > svg {
    margin-right: 20px;
    max-width: 32.5%;
    min-width: 32.5%;
  }
`

export const WizardTitle = styled.h2`
  color: ${colors.blue1};
  margin-bottom: 35px;
`

export const WizardForm = styled.form`
  margin: 0;
  width: 100%;
`

export const WizardStepContainer = styled.div`
  display: none;
  flex-direction: column;

  &.visible {
    display: flex;
  }
`

export const WizardRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
`

export const WizardColumn = styled.div`
  align-content: center;
  display: flex;
  flex-direction: column;
  margin: 0 10px;
  width: 100%;

  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
`
